import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const ReloadIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.54757 4.35129C10.968 3.72934 13.4522 4.69515 14.81 6.66673L8.54757 4.35129ZM14.81 6.66673H12.4999C12.0397 6.66673 11.6666 7.03983 11.6666 7.50007C11.6666 7.9603 12.0397 8.3334 12.4999 8.3334H16.1755C16.1881 8.33369 16.2007 8.33369 16.2132 8.3334H16.6666C17.1268 8.3334 17.4999 7.9603 17.4999 7.50007V3.3334C17.4999 2.87316 17.1268 2.50007 16.6666 2.50007C16.2063 2.50007 15.8333 2.87316 15.8333 3.3334V5.25355C14.0271 3.02859 11.0355 1.99108 8.13255 2.73712L8.13238 2.73716C6.81378 3.07634 5.61239 3.76805 4.65704 4.73812C3.70169 5.70819 3.02843 6.92002 2.70946 8.24365C2.39049 9.56728 2.43784 10.9528 2.84644 12.2515C3.25504 13.5503 4.00948 14.7133 5.02883 15.6159C6.04818 16.5185 7.294 17.1265 8.63268 17.3749C9.97135 17.6232 11.3524 17.5025 12.6277 17.0256C13.9029 16.5487 15.0243 15.7337 15.8716 14.6679C16.7189 13.6022 17.26 12.3259 17.4371 10.9759C17.4969 10.5196 17.1755 10.1011 16.7192 10.0413C16.2628 9.98146 15.8444 10.3029 15.7845 10.7592C15.6469 11.8092 15.2259 12.8019 14.567 13.6308C13.908 14.4597 13.0358 15.0936 12.0439 15.4645C11.052 15.8354 9.97788 15.9293 8.93669 15.7362C7.8955 15.543 6.92653 15.0701 6.1337 14.3681C5.34087 13.6661 4.75409 12.7615 4.43628 11.7513C4.11848 10.7412 4.08165 9.6636 4.32974 8.63411C4.57783 7.60462 5.10148 6.66209 5.84453 5.90759C6.58753 5.15313 7.52188 4.61515 8.54739 4.35133"
          fill="#9C99A6"
        />
      </svg>
    </Center>
  );
};
